import { render } from "./LogicalMemoryRobert.vue?vue&type=template&id=1c52541e&scoped=true"
import script from "./LogicalMemoryRobert.vue?vue&type=script&lang=js"
export * from "./LogicalMemoryRobert.vue?vue&type=script&lang=js"

import "./LogicalMemoryRobert.vue?vue&type=style&index=0&id=1c52541e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c52541e"]])

export default __exports__